module.exports = __webpack_public_path__ + "static/media/icon-executive-summary.3860cf62.svg";